// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const SalesOrderPaymentStatus = {
  OpenBalance: {
    Name: 'Open Balance',
    Value: 'open_balance',
    Icon: 'ReceiptText',
    Variant: 'secondary',
  },
  PartiallyPaid: {
    Name: 'Partially Paid',
    Value: 'partially_paid',
    Icon: 'WalletCards',
    Variant: 'warning',
  },
  Paid: {
    Name: 'Paid',
    Value: 'paid',
    Icon: 'CircleCheck',
    Variant: 'success',
  },
} as const

export type SalesOrderPaymentStatusValue =
  (typeof SalesOrderPaymentStatus)[keyof typeof SalesOrderPaymentStatus]['Value']
